module.exports = __webpack_public_path__ + "img/photo_one.44c9bd2e.png";